import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const PERMIT_LOCATIONS_PATH = 'api/PermitLocations';

export const getPermitLocations = (params) => makeRequest(
  authFetch.get(`${PERMIT_LOCATIONS_PATH}${getQueryParams(params)}`),
);

export const getPermitLocationById = (permitLocationId) => makeRequest(
  authFetch.get(`${PERMIT_LOCATIONS_PATH}/${permitLocationId }`),
);

export const savePermitLocation = (permitLocation) => makeRequest(
  authFetch.put(PERMIT_LOCATIONS_PATH, permitLocation),
);

export const deletePermitLocation = (permitLocationId) => makeRequest(
  authFetch.delete(`${PERMIT_LOCATIONS_PATH}/${permitLocationId }`),
);

export const restorePermitLocation = (permitLocationId) => makeRequest(
  authFetch.patch(`${PERMIT_LOCATIONS_PATH}/${permitLocationId }/restore`),
);

export const setApprovalStatus = (permitLocationId, statusId) => makeRequest(
  authFetch.patch(`${PERMIT_LOCATIONS_PATH}/${permitLocationId }/approval`, statusId),
);

export const getPermitLocationAudits = (permitLocationId, params) => makeRequest(
  authFetch.get(`${PERMIT_LOCATIONS_PATH}/${permitLocationId}/audits${getQueryParams(params)}`),
);

export const getPermitLocationAuditProperties = (permitLocationId) => makeRequest(
  authFetch.get(`${PERMIT_LOCATIONS_PATH}/${permitLocationId}/audits/properties`),
);

export const getPermitLocationAuditUsers = (permitLocationId) => makeRequest(
  authFetch.get(`${PERMIT_LOCATIONS_PATH}/${permitLocationId}/audits/users`),
);
